import React from "react";
import { Plus, Brain, Calendar, ExternalLink } from "lucide-react";
import { Button } from "../UI";
import JobBoardChips from "./JobBoardChips";

export default function JobsListModal({
  isOpen,
  jobs = [],
  theme,
  fonts,
  onClose,
  onOpenJobModal,
  onSelectJobForScreening,
  onSelectJobForShortlisting,
  onOpenBoardToPost
}) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, zIndex: 1000
    }}>
      <div style={{ background: theme.surface, border: `1px solid ${theme.line}`, borderRadius: 14, padding: 28, width: "100%", maxWidth: 650, maxHeight: "85vh", overflowY: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
          <div>
            <h3 style={{ fontSize: 18, fontWeight: 700, margin: 0, fontFamily: fonts?.display }}>Your Job Postings ({jobs.length})</h3>
            <p style={{ fontSize: 12, color: theme.textMute, margin: "2px 0 0" }}>Click on any job to screen candidates or shortlist applicants</p>
          </div>
          <Button theme={theme} onClick={() => { onClose(); onOpenJobModal(); }} style={{ padding: "6px 12px", fontSize: 12 }}>
            <Plus size={13} /> Post New Job
          </Button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {jobs.length === 0 ? (
            <div style={{ border: `1px dashed ${theme.line}`, borderRadius: 8, padding: 24, textAlign: "center", color: theme.textMute, fontSize: 13 }}>
              No jobs posted yet. Click "Post New Job" above to create your first posting.
            </div>
          ) : (
            jobs.map(j => (
              <div key={j.id} style={{ border: `1px solid ${theme.line}`, borderRadius: 10, padding: 16, background: theme.bg }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <h4 style={{ fontWeight: 700, fontSize: 15, margin: 0 }}>{j.role}</h4>
                    <div style={{ fontSize: 12, color: theme.textMute, marginTop: 4 }}>
                      <strong>Salary:</strong> {j.salary_range} | <strong>Experience:</strong> {j.experience}{j.location ? ` | ${j.location}` : ""}
                    </div>
                    <div style={{ fontSize: 12, color: theme.accent, marginTop: 4 }}>
                      <strong>Skills Required:</strong> {j.skills}
                    </div>
                    <JobBoardChips boardPosts={j.boardPosts} platforms={j.platforms} />
                    <div style={{ fontSize: 11, color: theme.textMute, marginTop: 6 }}>Not live on Indeed / LinkedIn until you publish there and paste the job URL.</div>
                  </div>
                  <span style={{ fontSize: 10, background: theme.accentDim, color: theme.accent, padding: "3px 8px", borderRadius: 6, fontWeight: 700 }}>
                    Active Job
                  </span>
                </div>

                <div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                  <Button theme={theme} onClick={() => {
                    onSelectJobForScreening(String(j.id));
                    onClose();
                  }} style={{ padding: "5px 12px", fontSize: 11 }}>
                    <Brain size={12} /> AI Screen Resume
                  </Button>
                  <Button theme={{ ...theme, surface: theme.line }} onClick={() => {
                    onSelectJobForShortlisting(String(j.id));
                    onClose();
                  }} style={{ padding: "5px 12px", fontSize: 11, background: "transparent", border: `1px solid ${theme.line}`, color: theme.text }}>
                    <Calendar size={12} /> Apply / Shortlist Candidate
                  </Button>
                  <Button theme={{ ...theme, surface: theme.line }} onClick={(e) => {
                    e.stopPropagation();
                    onOpenBoardToPost(j, "indeed");
                  }} style={{ padding: "5px 12px", fontSize: 11, background: "transparent", border: `1px solid ${theme.line}`, color: theme.text }}>
                    <ExternalLink size={12} /> Post on Indeed
                  </Button>
                  <Button theme={{ ...theme, surface: theme.line }} onClick={(e) => {
                    e.stopPropagation();
                    onOpenBoardToPost(j, "linkedin");
                  }} style={{ padding: "5px 12px", fontSize: 11, background: "transparent", border: `1px solid ${theme.line}`, color: theme.text }}>
                    <ExternalLink size={12} /> Post on LinkedIn Jobs
                  </Button>
                  <Button theme={{ ...theme, surface: theme.line }} onClick={(e) => {
                    e.stopPropagation();
                    onOpenBoardToPost(j, "naukri");
                  }} style={{ padding: "5px 12px", fontSize: 11, background: "transparent", border: `1px solid ${theme.line}`, color: theme.text }}>
                    <ExternalLink size={12} /> Post on Naukri
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <Button theme={{ ...theme, surface: theme.line }} onClick={onClose} style={{ background: "transparent", border: `1px solid ${theme.line}`, color: theme.text }}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
